<template>
    <div class="container-fluid px-0 z-0">
        <div class="container px-0">
            <div>
                <div class="col-12 col-lg-10 px-0">
                    <div class="cmp-breadcrumbs" role="navigation">
                        <nav class="breadcrumb-container bread" aria-label="Percorso di navigazione">
                            <ol style="background-color:transparent" class="breadcrumb p-0" :class="background" data-element="breadcrumb">
                                <li :class="`breadcrumb-item` + (node.route && node.route == this.$route.path && node.route != '/index.html' ? ' active' : '')" v-for="node in nodes" :key="node.title">
                                    <div v-if="node.route && ! node.route.includes('http')">
                                        <RouterLink v-if="node.route" :to="node.route" class="breadcrumb-link tooltip-enabled" :data-full-title="node.title">
                                            {{ formatTitle(node.title) }}
                                        </RouterLink>
                                        <span v-else class="breadcrumb-text tooltip-enabled" :data-full-title="node.title">
                                            {{ formatTitle(node.title) }}
                                        </span>
                                        <span v-if="node !== this.article && nodes.length > 2" class="separator">
                                            /
                                        </span>
                                    </div>
                                    <div v-else>
                                        <a :target="node.attr.target" v-if="node.route" :href="node.route" class="breadcrumb-link tooltip-enabled" :data-full-title="node.title">
                                            {{ formatTitle(node.title) }}
                                        </a>
                                        <span v-else class="breadcrumb-text tooltip-enabled" :data-full-title="node.title">
                                            {{ formatTitle(node.title) }}
                                        </span>
                                        <span v-if="node !== this.article" class="separator">/</span>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.breadcrumb-link.tooltip-enabled,
.breadcrumb-text.tooltip-enabled {
    position: relative;
}

.breadcrumb-link.tooltip-enabled:hover::after,
.breadcrumb-text.tooltip-enabled:hover::after {
    content: attr(data-full-title);
    position: absolute;
    top: 100%;
    left: 0;
    background-color: rgba(52, 58, 64, 0.95);
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    white-space: normal;
    max-width: 300px;
    word-wrap: break-word;
    backdrop-filter: blur(2px);
    transition: opacity 0.2s ease-in-out;
}

</style>

<script>
import { ArticleNode, SectionNode } from '@/classes/tree'

export default {
    name: "BreadcrumbNode",
    data() {
        return {
            maxLength: 80,
            nodes: null
        };
    },
    props: {
        article: {
            type: ArticleNode,
            required: false
        },
        section: {
            type: SectionNode,
            required: false
        },
        background: {
            type: String,
            required: true,
            default: 'dark'
        }
    },
    created() {
        this.updateBreadcrumb();
    },
    methods: {
        isTruncated(title) {
            return title && title.length > this.maxLength;
        },
        formatTitle(title) {
            if (!title) return '';
            return this.isTruncated(title) ? title.substr(0, this.maxLength) + '...' : title;
        },
        updateBreadcrumb() {
            // Initialize with default breadcrumb items
            this.nodes = [{ "title": "Home", "route": "https://www.serviziocontrattipubblici.it/", "attr": { target: "_blank" } }, {"title": "Codice dei Contratti Pubblici Digitalizzato", "route" : "/index.html"}];

            if (this.$route.path === '/informativa-privacy') {
                this.nodes.push({ "title": "Informativa Privacy", "route": "/informativa-privacy" });
                return;
            }

            if (this.$route.path === '/politica-utilizzo') {
                this.nodes.push({ "title": "Politica di utilizzo Chatbot AI4RUP", "route": "/politica-utilizzo" });
                return;
            }
            
            // Check if contentTree is available
            if (!this.$root.contentTree) {
                return;
            }
            
            // Add article chain if article is defined
            if (this.article !== null) {
                try {
                    const articleChain = this.$root.contentTree.getChain(this.article);
                    if (articleChain) {
                        this.nodes = this.nodes.concat(articleChain);
                    }
                } catch (error) {
                    console.error('Error getting article chain:', error);
                }
            }
            
            // Add section chain if section is defined
            if (this.section !== null) {
                try {
                    const sectionChain = this.$root.contentTree.getChain(this.section);
                    if (sectionChain) {
                        this.nodes = this.nodes.concat(sectionChain);
                    }
                } catch (error) {
                    console.error('Error getting section chain:', error);
                }
            }
        }
    },
    watch: {
        // Watch for changes in article prop
        article: {
            handler() {
                this.updateBreadcrumb();
            },
            deep: true
        },
        // Watch for changes in section prop
        section: {
            handler() {
                this.updateBreadcrumb();
            },
            deep: true
        },
        $route: {
            handler() {
                this.updateBreadcrumb();
            }
        }
    }
}
</script>